import script from "./EditableCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditableCell.vue?vue&type=script&setup=true&lang=ts"

import "./EditableCell.vue?vue&type=style&index=0&id=9bd6a3cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd6a3cc"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QIcon});
